module.exports = __webpack_public_path__ + "media/images/frontend/logo_white-22a20846cce23bfdf759edde7f9a0d3f.png";